/** Dispara o download de um blob (ex.: XLSX/ZIP retornado pela API) no navegador. */
export function downloadBlob(data: BlobPart, filename: string): void {
  const url = URL.createObjectURL(new Blob([data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
